import React from "react";
import { Col, Row } from "reactstrap";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import * as S from "src/constants/StringConstants";

const DeliveryInformationForm = () => {
  return (
    <>
      <Row>
        <Col sm="12" className="app-form-header">
          <h4 className="form-title">{S.APP_DELIVERY_INFORMATION_TITLE}</h4>
        </Col>
      </Row>
      <Row style={{ display: "flex", gap: 105 }}>
        <Row>
          <Col sm="6">
            <SimpleDatePickerField label={S.APP_ISSUE_DATE_LABEL} name="deliveryOrderDate" isFormMode showClear />
          </Col>
          <Col sm="6">
            <SimpleDatePickerField label={S.APP_DUE_DATE_LABEL} name="deliveryDueDate" isFormMode showClear />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <TextField name="underwriter" label={S.APP_UNDERWRITER_LABEL} />
          </Col>
          <Col sm="12">
            <TextField name="assistant" label={S.APP_ASSISTANT_LABEL} />
          </Col>

          <Col sm="12">
            <TextField name="misc" label={S.APP_MISC_LABEL} />
          </Col>

          <Col sm="12">
            <TextField name="multiLife" label={S.APP_MULTI_LIFE_CODE_LABEL} />
          </Col>

          <Col sm="12">
            <TextField name="businessOwner" label={S.APP_BUSINESS_OWNER_LABEL} />
          </Col>
        </Row>
      </Row>
    </>
  );
};

export default DeliveryInformationForm;
